import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

let baseURL = '';
const urlPath = window.location.pathname; // e.g., "/ca/admin"
const part = urlPath.split('/')[1];
// if (part == 'ca') baseURL = 'https://apistagca.amacvoters.org';
// else if (part == 'wa') baseURL = 'https://apistag.amacvoters.org';
// else baseURL = 'https://apistag.amacvoters.org';

if (part == 'ca') baseURL = 'https://apistagca.amacvoters.org';
else if (part == 'wa') baseURL = 'https://apistag.amacvoters.org';
else baseURL = 'https://apistag.amacvoters.org';

//https://api.amacvoters.org
//https://api-ca.amacvoters.org
//https://apistag.amacvoters.org

//URL fo API request
export const Axios = axios.create({
  // baseURL: 'https://idelivery.inabia.com/api', //Staging
  // baseURL: 'https://api.amacvoters.org', //Amac
  baseURL,
  headers: {
    'Accept': 'application/json'
  }
});

// WA-only Axios instance (use for Contacts module)
export const AxiosWA = axios.create({
  baseURL: 'https://apistag.amacvoters.org',
  headers: {
    'Accept': 'application/json'
  }
});

//Project Name
export const projectName = {
  Path: 'AMAC voters' //Admin
};

export const S3bucket = {};

//Initialize user login parameters for API calls
const applyCommonInterceptors = (client: AxiosInstance) => {
  client.interceptors.request.use((config) => {
  const userId = localStorage.getItem('userId');

  const token = localStorage.getItem('token');
  const times = Date.now();

  config.params = {
    times,
    ...config.params
  };
  if (userId && token) {
    config.params = {
      userId,
      token,
      ...config.params
    };
  } else if (!userId && !token) {
    const token = 'sdddwddwdwdwwd';
    config.params = {
      ...config.params
    };
  }
    return config;
  });

const MAX_RETRIES = 3;
const RETRY_DELAY = 500; // 3 minutes

// Response Interceptor with Retry Logic
  client.interceptors.response.use(
    (response: AxiosResponse) => response,
    async (error: AxiosError) => {
      const config = error.config as AxiosRequestConfig & {
        __retryCount?: number;
      };

      // Do not retry for client errors (e.g., 400–499)
      const status = error.response?.status;
      if (status && status >= 400 && status < 500) {
        return Promise.reject(error);
      }

      // Track retry count
      config.__retryCount = config.__retryCount ?? 0;

      if (config.__retryCount < MAX_RETRIES) {
        config.__retryCount += 1;
        await new Promise((res) => setTimeout(res, RETRY_DELAY));
        return client(config);
      }

      return Promise.reject(error);
    }
  );
};

applyCommonInterceptors(Axios);
applyCommonInterceptors(AxiosWA);

export const Segment = {
  tracking: true //true or false
};

// Api Calls
export enum API {
  NetworkError = '/ediscoveryAPI.php',
  forgotPassAWS = '/forgot',
  forgotPassCodeAWS = '/confirmforgot',
  loginAWS = '/login',
  registerAWS = '/signup',
  AWSauth = '/AWSauth',
  signupAWSCode = '/verify',
  changePassAWS = 'changePassAWS',
  S3UploadPath = 'S3UploadPath',
  VoterData = '/getData',
  ResendVerificationCode = 'resendCode',
  updateEthnicity = '/update',
  search = '/search',
  getAnalytics1 = '/getAnalytics1',
  getAnalytics2 = '/getAnalytics2',
  getUserData = '/getUserData',
  updateUserStatus = '/updateUserStatus',
  updateUserVersion = '/updateUserVersion',
  getCountries = '/getCountries',
  getCountries2 = '/checkAPI',
  getDataSh = '/getDataSh',
  signupNew = '/signupNew',
  deleteUser = '/deleteUser',
  disableUser = '/disableUser',
  searchDynamoDB = '/searchDynamoDB',
  searchClickHouse = '/searchClickHouse', //searchClickHouseDecrypt
  DownloadAccess = '/DownloadAccess',
  searchPostgres = '/searchPostgres',
  updateEthnicityClickhouse = '/updateEthnicityClickhouse',
  ReligionClassifications = '/ReligionClassifications',
  updateReligionClickhouse = '/updateReligionClickhouse',
  userActivityLogs = '/userActivityLogs',
  disableUserAdmin = '/disableUserAdmin',
  signupNewAdmin = '/signupNewAdmin',
  userActivityLogs1M = '/userActivityLogs1M',
  searchClickHouse2 = '/searchClickHouse',
  addOwnership = '/addOwnership',
  getOwnership = '/getOwnership',
  deleteOwnership = '/deleteOwnership',
  updateOwnershipClickHouse = '/updateOwnershipClickHouse',
  votingData = 'votingData',
  getCities = 'getCities',
  getAnalytics3 = 'getAnalytics3',
  downloadMuslimVoters = 'downloadMuslimVoters',
  getAugStatus = 'getAugStatus',
  getBallotStatus = 'getBallotStatus',
  tshirtCommunities = 'tshirtCommunities',
  getAnalyticsCountryWise = 'getAnalyticsCountryWise',
  updateDownloadStatus = 'updateDownloadStatus',
  getVoterResult = 'getVoterResult',
  getRegisteredVotersEthnicity = 'getRegisteredVotersEthnicity',
  getReasons = 'getReasons',
  addReasons = 'addReasons',
  delReasons = 'delReasons',
  editReasons = 'editReasons',
  updateReasonClickhouse = 'updateReasonClickhouse',
  updateAllowAccess = 'updateAllowAccess',
  updatePhoneNumber = 'updatePhoneNumber',
  loginMFA = 'loginMFA',
  sendOTP = 'sendOTP',
  verifyOTP = 'verifyOTP',
  logout = 'logout',
  communityDemographics = 'communityDemographics',
  searchClickHouseDecrypt = 'searchClickHouseDecrypt',
  totalMuslimVotersCount = 'totalMuslimVotersCount',
  searchClickHousePagination = 'searchClickHousePagination',
  searchClickHouseDecryptPagination = 'searchClickHouseDecryptPagination',
  changeState = 'changeState',
  downloadMuslimVotersAll = 'downloadMuslimVotersAll',
  religion_classified_by = 'religion_classified_by',
  updateRCBY = 'updateRCBY',
  fileUploadS3 = 'fileUploadS3',
  candidateEvents = 'candidateEvents',
  loginMFASQL = 'loginMFASQL',
  getAnalyticsCountryWisePE2025 = 'getAnalyticsCountryWisePE2025',
  getRegisteredVotersEthnicityPE2025 = 'getRegisteredVotersEthnicityPE2025',
  updateReasonClickhousePE2025Aug = 'updateReasonClickhousePE2025Aug',
  States = 'States',
  uploadLogin = 'uploadLogin',
  getAnalyticsCountryWiseNov2025 = 'getAnalyticsCountryWiseNov2025',
  getRegisteredVotersEthnicityNov2025 = 'getRegisteredVotersEthnicityNov2025',
  getAdvanceOptions = 'getAdvanceOptions',
  DownloadLimit = 'DownloadLimit',
  getCandidateLogs = 'getCandidateLogs',
  getSignedURL = 'getSignedURL',
  fuzzySearch = 'fuzzySearch',
  totalMuslimVotersCountFuzzy = 'totalMuslimVotersCountFuzzy',
  matchContacts = 'matchContacts',
  searchContact = 'searchContact',
  saveContactMatches = 'saveContactMatches',
  getContacts = 'getContacts',
  getContactsNew = 'getContactsNew',
  fuzzySearchApp = 'fuzzySearchApp',
  getRelations = 'getRelations',
  saveContact = 'saveContactNew',
  getContactDetails = 'getContactDetails',
  getContactDetailsSteps = 'getContactDetailsStepsNew',
  advanceRefineSearch = 'advanceRefineSearch',
  getMessageTemplates = 'getMessageTemplates',
  editContactRelation = 'editContactRelation',
  sendMessageSave = 'sendMessageSave',
  deleteContact = 'deleteContact',
  editContact = 'editContact',
  voterImpact = 'voterImpact',
  contactDetailsUpdate = 'contactDetailsUpdate',
  getContactsCatWise = 'getContactsCatWise',
  getFilters = 'getFilters',
  getFiltersNew = 'getFiltersNew',
  UpdateGoal = 'updateGoal',
  updateStepStatus = 'updateStepStatus',
  updateNotes = 'updateNotes',
  getAllCaptainsRelations = 'getAllCaptainsRelations',
  RelationAccess = 'RelationAccess'

}

export default Axios;
